import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  FormControl: {
    width: "100%"
  }
});

export default withStyles(styles);
